export default function useDashboard() {
  const tooltipAreaChartContent = (title: string, graph: string, data: string, variation: number): string => {
    let variationWithIcon = ''

    let svgVariationClass, pVariationClass
    if (variation === 0) {
      svgVariationClass = 'text-foreground'
      pVariationClass = 'text-foreground'
    } else if (variation > 0) {
      svgVariationClass = 'text-green-800'
      pVariationClass = 'text-green-800'
    } else {
      svgVariationClass = 'rotate-180 text-red-800'
      pVariationClass = 'text-red-800'
    }

    variationWithIcon =
      `<svg class="self-center shrink-0 h-5 w-5 transform ${svgVariationClass}"` +
      `xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
      </svg>
      <p class="font-bold ` +
      `${pVariationClass}` +
      `">${parseFloat(Number(variation).toFixed(2))}%</p>`

    const content = `<div class="w-full flex flex-col">
      <div class="bg-primary font-medium px-6 py-3 text-center">
        <p class="text-white">
          ${title}
        </p>
      </div>
      <div class="flex p-3 px-6 text-center text-foreground">
        <p class="mr-2">${graph}: <span class="font-bold">${data}</span></p>
        ${variationWithIcon}
      </div>
    </div>`
    return content
  }

  const tooltipAreaHeatmapContent = (title: string, data: string, name: string): string => {
    const content = `<div class="w-full flex flex-col">
    <div class="bg-primary font-medium px-6 py-3 text-center">
      <p class="text-white">
        ${title}
      </p>
    </div>
    <div class="flex p-3 text-center text-foreground">
      <p class="mr-2">${data} ${name}</p>
    </div>
  </div>`
    return content
  }
  return {
    tooltipAreaChartContent,
    tooltipAreaHeatmapContent
  }
}
